import React from "react";
import { Helmet } from "react-helmet-async";
import { BUSINESS, SITE_URL, SITE_NAME, DEFAULT_IMAGE } from "../data/seoConfig";

// Site-wide LocalBusiness structured data (NAP, geo, areas served, price range).
// Boosts local SEO / Google local pack visibility for Barnum Événement.
const data = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "Store"],
  "@id": SITE_URL + "/#business",
  name: SITE_NAME,
  legalName: BUSINESS.legalName,
  description:
    "Location, livraison, montage et démontage de barnums, chapiteaux, tentes de réception, mobilier et vaisselle en Normandie. Structures conformes CTS (arrêté du 23 janvier 1985), toiles ignifugées M2.",
  taxID: BUSINESS.siren,
  url: SITE_URL,
  image: DEFAULT_IMAGE,
  logo: DEFAULT_IMAGE,
  email: BUSINESS.email,
  telephone: BUSINESS.phones[0],
  priceRange: BUSINESS.priceRange,
  address: {
    "@type": "PostalAddress",
    streetAddress: BUSINESS.street,
    postalCode: BUSINESS.postalCode,
    addressLocality: BUSINESS.city,
    addressRegion: BUSINESS.region,
    addressCountry: BUSINESS.country,
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: BUSINESS.latitude,
    longitude: BUSINESS.longitude,
  },
  areaServed: BUSINESS.areasServed.map((name) => ({ "@type": "City", name })),
  sameAs: BUSINESS.sameAs,
  knowsAbout: [
    "Location de barnum",
    "Location de chapiteau",
    "Normes CTS arrêté du 23 janvier 1985",
    "Toile ignifugée M2 NF P92-507",
    "Ancrage et lestage de structures événementielles",
    "Organisation de mariage en Normandie",
  ],
  department: [
    {
      "@type": "LocalBusiness",
      name: "Pôle logistique de Gainneville – Barnum Événement",
      description:
        "Dépôt, préparation et départ des livraisons de barnums, chapiteaux, mobilier et vaisselle pour toute la Normandie.",
      address: {
        "@type": "PostalAddress",
        streetAddress: BUSINESS.street,
        postalCode: BUSINESS.postalCode,
        addressLocality: BUSINESS.city,
        addressRegion: BUSINESS.region,
        addressCountry: BUSINESS.country,
      },
      telephone: BUSINESS.phones[1],
    },
  ],
  makesOffer: [
    {
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "Location de barnum et chapiteau avec montage",
        serviceType: "Location de structure événementielle",
      },
      areaServed: { "@type": "AdministrativeArea", name: "Normandie" },
    },
    {
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "Pack mariage clé en main",
        description:
          "Chapiteau cristal, plancher bois isolant, tables rondes, chaises Napoléon et vaisselle complète restituée sale.",
      },
    },
  ],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "08:00",
      closes: "19:00",
    },
  ],
};

const LocalBusinessJsonLd = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(data)}</script>
  </Helmet>
);

export default LocalBusinessJsonLd;
